export class LayerSet {

    public normalLayer: PIXI.Container;
    public normalSpecial: PIXI.Container;
    public xWLayer: PIXI.Container;
    public wildLayer: PIXI.Container;
    public xSplitLayer: PIXI.Container;
    public removalSymLayer: PIXI.Container;
    public scatterLayer: PIXI.Container;
    public enhancerBlockLayer: PIXI.Container;//safe + enhancers
    public safeLayer: PIXI.Container;
    public enhancerBlockOpenedLayer: PIXI.Container;
    public fullWildSymbols: PIXI.Container;
    public winLayer: PIXI.Container;
    public maskedEffectsLayer: PIXI.Container;

    constructor(suffix: string = "") {

        this.normalLayer = new PIXI.Container();
        this.normalLayer.name = "normalLayer" + suffix;

        this.normalSpecial = new PIXI.Container();
        this.normalSpecial.name = "normalSpecial" + suffix;

        this.xWLayer = new PIXI.Container();
        this.xWLayer.name = "xwLayer" + suffix;

        this.wildLayer = new PIXI.Container();
        this.wildLayer.name = "wildLayer" + suffix;

        this.xSplitLayer = new PIXI.Container();
        this.xSplitLayer.name = "xSplitLayer" + suffix;

        this.removalSymLayer = new PIXI.Container();
        this.removalSymLayer.name = "removalSymLayer" + suffix;

        this.scatterLayer = new PIXI.Container();
        this.scatterLayer.name = "scatterLayer" + suffix;


        this.enhancerBlockLayer = new PIXI.Container();
        this.enhancerBlockLayer.name = "enhancerBlockLayer" + suffix;

        this.safeLayer = new PIXI.Container();
        this.safeLayer.name = "safeLayer" + suffix;

        this.enhancerBlockOpenedLayer = new PIXI.Container();
        this.enhancerBlockOpenedLayer.name = "enhancerBlockOpened" + suffix;

        this.fullWildSymbols = new PIXI.Container();
        this.fullWildSymbols.name = "FullWildSymbols" + suffix;

        this.winLayer = new PIXI.Container();
        this.winLayer.name = "winSymbolsLayer" + suffix;

        this.maskedEffectsLayer = new PIXI.Container();
        this.maskedEffectsLayer.name = "maskedEffectsLayer" + suffix;
    }


    public addLayerSet(layers: LayerSet): void {
        this.normalLayer.addChild(layers.normalLayer);
        this.normalSpecial.addChild(layers.normalSpecial);
        this.xWLayer.addChild(layers.xWLayer);
        this.wildLayer.addChild(layers.wildLayer);
        this.xSplitLayer.addChild(layers.xSplitLayer);
        this.removalSymLayer.addChild(layers.removalSymLayer);
        this.scatterLayer.addChild(layers.scatterLayer);
        this.enhancerBlockLayer.addChild(layers.enhancerBlockLayer);
        this.safeLayer.addChild(layers.safeLayer);
        this.enhancerBlockOpenedLayer.addChild(layers.enhancerBlockOpenedLayer);
        this.fullWildSymbols.addChild(layers.fullWildSymbols);
        this.winLayer.addChild(layers.winLayer);
        this.maskedEffectsLayer.addChild(layers.maskedEffectsLayer);

    }

}